import { Bolt, TypeSpecimenOutlined } from "@mui/icons-material"
import { Box, Button, Card, CardContent, Grid, TableContainer, Typography } from "@mui/material"


export const TablaAyudGes: React.FC = () =>{
    return(
        <Box marginTop={5}>

            <Card sx={{ width: 300, borderRadius: 5 }}>
                <CardContent>
                    <Typography>BIOLOGÍA GENERAL</Typography>
                    <Typography>FCV</Typography>
                    <Typography>BIOG1022</Typography>
                    <Typography>TEÓRICO</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={10}>
                            <Typography fontSize={11}>Número de plazas planificadas: </Typography>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Typography fontSize={11}>2</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={10}>
                            <Typography fontSize={11}>Horas por plaza planificada: </Typography>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Typography fontSize={11}>5</Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={10}>
                            <Typography fontSize={11}>Horas totales: </Typography>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Typography fontSize={11}>10</Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} marginTop={1} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <Grid item xs={12} md={4}>
                            <Typography fontSize={12}>POSTULAR</Typography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Button sx={{border:"solid 1px", borderColor:"blue"}}><Typography fontSize={11}>5 horas</Typography></Button>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Button sx={{border:"solid 1px", borderColor:"blue"}}><Typography fontSize={11}>10 horas</Typography></Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            
            
        </Box>
    )


}